import { DIAGNOSIS_SUB_SECTION_IDS } from 'src/consumer/constants'
import { getValidNumberFromStringNumber, isValidNumber } from 'src/consumer/helpers/utilFunctions'

export function getRenderDiagnosisSubSectionsSet(subSectionsArray) {
  const subsectionsSet = new Set()
  if (
    Boolean(
      Array.isArray(subSectionsArray) &&
        subSectionsArray.find((item) => item?.uid === 'diagnosis_title') &&
        subSectionsArray.find((item) => item?.uid === 'diagnosis_title')?.selected,
    )
  ) {
    subsectionsSet.add('diagnosis_title')
  }

  if (
    Boolean(
      Array.isArray(subSectionsArray) &&
        subSectionsArray.find((item) => item?.uid === 'diagnosis_for_duration') &&
        subSectionsArray.find((item) => item?.uid === 'diagnosis_for_duration')?.selected,
    )
  ) {
    subsectionsSet.add('diagnosis_for_duration')
  }

  if (
    Boolean(
      Array.isArray(subSectionsArray) &&
        subSectionsArray.find((item) => item?.uid === 'diagnosis_since_date') &&
        subSectionsArray.find((item) => item?.uid === 'diagnosis_since_date')?.selected,
    )
  ) {
    subsectionsSet.add('diagnosis_since_date')
  }
  return subsectionsSet
}

export function isDiagnosisSectionIsATable(dSection) {
  const dSubSections = dSection?.subSections || []

  const eligibleSubSections = dSubSections?.filter((ss) => ss?.selected)


  return (
    !!dSubSections &&
    eligibleSubSections.length > 1 &&
    eligibleSubSections.map((ss) => ss?.uid).includes(DIAGNOSIS_SUB_SECTION_IDS.diagnosis_title.id)
  )
}

export async function loadOptionsDiagnosisDuration(search, loadedOptions, { page }) {
  const optns = getDiagnosisDurationArray(search)

  return {
    options: optns,
    hasMore: false,
    additional: {
      page: page + 1,
    },
  }
}

export const INITIAL_DIAGNOSIS_OPTION_ARRAY_LIST = [
  { id: '__ hour', title: '__ hour' },
  { id: '__ day', title: '__ day' },
  { id: '__ week', title: '__ week' },
  { id: '__ month', title: '__ month' },
  { id: '__ year', title: '__ year' },
]

function getDiagnosisDurationArray(searchNumber) {
  let finalArray = INITIAL_DIAGNOSIS_OPTION_ARRAY_LIST

  let initialNumber = getValidNumberFromStringNumber(searchNumber)
  if (!initialNumber) {
    return finalArray
  }

  return finalArray.map((itm) => {
    let updatedTitle = itm.title.replace('__', initialNumber)
    if (initialNumber > 1) {
      updatedTitle += 's'
    }
    return {
      id: itm.id.replace('__', initialNumber) + (initialNumber > 1 ? 's' : ''),
      title: updatedTitle,
    }
  })
}
